import React, { Component } from 'react'
import PropTypes from 'prop-types'
import HobnobModal from 'src/components/common/HobnobModal'
import { connect } from 'react-redux'
import dateformat from 'dateformat'

import SvgIcon from 'src/components/common/SvgIcon'

import { mailtoLink, twitterLink, facebookLink, smsLink } from 'services/share'
import { isMobile } from 'services/browser_detection'

import {
  eventSelector,
  hostSelector,
  shareModalIconTopSelector,
  shareModalIconBottomSelector,
  shareModalVisibleSelector
} from 'src/selectors'

import { hideShareModal } from 'src/actions/frontend'

import ShareEmailIcon from 'src/assets/icons/share_email.svg'
import ShareFacebookIcon from 'src/assets/icons/share_facebook.svg'
import ShareTextIcon from 'src/assets/icons/share_text.svg'
import ShareTwitterIcon from 'src/assets/icons/share_twitter.svg'

import styles from './share-event-modal-container.scss'

export class ShareEventModalContainer extends Component {
  _handleClose = () => {
    this.props.dispatch(hideShareModal())
  }

  _ignoreClick = (e) => e.stopPropagation()

  _displayAboveIcon () {
    if (typeof window === 'undefined') return true
    return this.props.iconTop > window.innerHeight / 4
  }

  _shareSubject (name) {
    const { event } = this.props

    return event.event_type === 'event' ? `You're invited to ${name}` : `Announcing: ${name}`
  }
  _mailtoLink () {
    const { event, host } = this.props
    let body = ''
    if (event.event_type === 'event') {
      body = `Can you make it to ${event.name}`

      if (event.starts_at) {
        const formattedDate = dateformat(event.starts_at, 'dddd, mmmm dS')
        body += ` on ${formattedDate}`
      }
      body += `?\n\n${event.email_share_url}`
    } else {
      body = 'Find out more details below!'
      if (host) {
        body += `\n\nFrom: ${host.first_name} ${host.last_name}`
      }
      body += `\n\n${event.email_share_url}`
    }

    const params = {
      subject: event.event_type === 'event' ? `You're invited to ${event.name}` : `We’re sharing the news with you about ${event.name}`,
      body
    }
    return mailtoLink(params)
  }

  _twitterLink () {
    const { event } = this.props
    const params = {
      subject: this._shareSubject(event.name) + '!',
      url: event.twitter_share_url
    }
    return twitterLink(params)
  }

  _facebookLink () {
    const { event } = this.props

    const params = {
      href: event.facebook_share_url,
      redirect_uri: event.url
    }
    return facebookLink(params)
  }

  _smsLink () {
    const { event } = this.props

    let subject = this._shareSubject(event.name)
    if (event.starts_at) {
      const formattedDate = dateformat(event.starts_at, 'dddd, mmmm dS')
      subject += ` on ${formattedDate}`
    }

    const params = {
      subject,
      fallbackSubject: "You're invited!",
      body: event.sms_share_url
    }
    return smsLink(params)
  }

  containerPosition () {
    if (typeof window === 'undefined') { return { top: 0 } }
    const { iconTop, iconBottom } = this.props
    const arrowPadding = 7
    const windowHeight = window.innerHeight

    if (this._displayAboveIcon()) {
      return {
        bottom: `${windowHeight - iconTop + arrowPadding}px`
      }
    } else {
      return {
        top: `${iconBottom + arrowPadding}px`
      }
    }
  }

  render () {
    const { visible } = this.props

    const containerStyles = {
      position: 'absolute',
      width: '100%',
      maxWidth: '100%',
      margin: '0 auto',
      left: '0',
      right: '0',
      background: 'transparent',
      padding: '0',
      ...this.containerPosition()
    }

    const containerClassName = this._displayAboveIcon() ? styles['modal-container-above'] : styles['modal-container-below']

    return (
      <HobnobModal
        containerClassName={containerClassName}
        containerStyles={containerStyles}
        show={visible}
        onClose={this._handleClose}
        showCancelIcon={false}
      >
        <div className={styles['modal-content']} onClick={this._ignoreClick}>
          <a className={styles['icon-container']} href={this._facebookLink()} target='_blank'>
            <SvgIcon className={styles['icon']} icon={ShareFacebookIcon} />
            <div className={styles['icon-label']}>Facebook</div>
          </a>
          {isMobile()
            ? <a className={styles['icon-container']} href={this._smsLink()}>
              <SvgIcon className={styles['icon']} icon={ShareTextIcon} />
              <div className={styles['icon-label']}>Text</div>
            </a>
            : null}
          <a className={styles['icon-container']} href={this._twitterLink()} target='_blank'>
            <SvgIcon className={styles['icon']} icon={ShareTwitterIcon} />
            <div className={styles['icon-label']}>Twitter</div>
          </a>
          <a className={styles['icon-container']} href={this._mailtoLink()} target='_blank'>
            <SvgIcon className={styles['icon']} icon={ShareEmailIcon} />
            <div className={styles['icon-label']}>Email</div>
          </a>
        </div>
      </HobnobModal>
    )
  }
}

ShareEventModalContainer.propTypes = {
  dispatch: PropTypes.func,
  iconTop: PropTypes.number,
  iconBottom: PropTypes.number,
  event: PropTypes.object,
  host: PropTypes.object,
  visible: PropTypes.bool
}

function mapStateToProps (state) {
  return {
    iconTop: shareModalIconTopSelector(state),
    iconBottom: shareModalIconBottomSelector(state),
    event: eventSelector(state),
    host: hostSelector(state),
    visible: shareModalVisibleSelector(state)
  }
}

export default connect(mapStateToProps)(ShareEventModalContainer)



// WEBPACK FOOTER //
// ./src/components/details/ShareEventModalContainer.jsx